<div #divContainer class="dx-validator dx-visibility-change-handler dx-show-invalid-badge dx-textbox dx-texteditor dx-editor-outlined dx-texteditor-empty dx-widget">
    <div class="dx-texteditor-container">
        <div class="dx-texteditor-input-container">
            <input
                #addressInstance
                class="dx-texteditor-input"
                type="text"
                spellcheck="false"
                tabindex="0"
                aria-required="true"
                [ngModel]="address"
                (ngModelChange)="addressChange.emit($event)"
                [ngModelOptions]="{standalone: true}"
            />
        </div>
    </div>

</div>
